<div class="container pairblank">
    <div class="row">
        <div class="d-flex align-items-start">
            <div class="col-sm-12 col-md-12 col-lg-8 mb-30-xs mb-30-sm">
                <nav class="accordion arrows">
                    <header class="box public-offering-header">
                        <h1>{{ipo?.name}}</h1>
                        <h2 style="font-size: 17px;">{{ipo?.code}}</h2>
                        <!--<h3 >Detaylı halka arz bilgileri, haberler, diğer bilgiler</h3>-->
                    </header>

                    <div class="row">
                        <div class="col" style="font-weight:bold;">Arz Tarihi</div>
                        <div class="col">{{ipo?.dateString}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;">Aracı Kurum</div>
                        <div class="col">{{ipo?.brokerageFirm}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;">Fiyatı/Aralığı</div>
                        <div class="col">{{ipo?.lowPrice}}-{{ipo?.highPrice}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold;">Pay</div>
                        <div class="col">{{ipo?.sharePiece}}</div>
                        <div class="w-100"></div>
                        <div class="col" style="font-weight:bold; margin-bottom: 10px;">Ek Pay</div>
                        <div class="col">{{ipo?.sharePiece}}</div>
                    </div>
                    <header class="box">
                        <h4>Haberler</h4>
                    </header>
                </nav>
            </div>
        </div>
    </div>
</div>